import * as React from "react";
import { SVGProps } from "react";
export const MinusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.04199 10.833C4.80599 10.833 4.60099 10.7463 4.42699 10.573C4.25366 10.399 4.16699 10.194 4.16699 9.958C4.16699 9.722 4.25366 9.51733 4.42699 9.344C4.60099 9.17 4.80599 9.083 5.04199 9.083H14.958C15.194 9.083 15.399 9.17 15.573 9.344C15.7463 9.51733 15.833 9.722 15.833 9.958C15.833 10.194 15.7463 10.399 15.573 10.573C15.399 10.7463 15.194 10.833 14.958 10.833H5.04199Z"
            fill="currentColor"
        />
    </svg>
);
MinusIcon.displayName = "MinusIcon";
